export const NUMBER_WITH_TWO_DECIMALS = /^\d*[.,]?\d{0,2}$/;

export const PHONE_NUMBER_REGEX =
  /^[\\+]?[(]?[0-9]{1,4}[)]?([-\s\\.]?[0-9]{2,6}){2,3}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
